import { feature as hiddenMarketsWidgetFlow } from '@central-products/hidden-markets-widget-flow';

export const hiddenMarketsPlugin = {
  beforeBootstrap({ addBootstrapperFeature }) {
    addBootstrapperFeature(hiddenMarketsWidgetFlow);
  },
};
